// Transform response; default behavior for every request made to API
import camelify from 'camelcase-keys-recursive';

const transformResponse = (response) => (response ? camelify(response) : response);

export default transformResponse;
